<template>
  <div id="ths-invoice-modal">

    <CustomerBillingTransactionListModal 
      :type="selected_type"
      :ths_invoice_id="id"
      ref="customer-transactions-modal"
    />

    
    <memlist-modal size="lg" ref="ths-invoice-modal">
      <m-row class="mt-4">
        <m-col cols="12" >
          <memlist-date-picker
            title="Förfallodatum"
            v-model="local_ths_invoice.due_date"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col cols="12" >
          <memlist-text-input
            title="Fakturanummer"
            v-model="local_ths_invoice.invoice_nr"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col cols="12" >
          <memlist-text-input
            title="Summa ex moms"
            v-model="local_ths_invoice.amount"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col cols="12" >
          <memlist-checkbox 
            title="Är betalad"
            v-model="local_ths_invoice.is_paid"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="12">
          <memlist-text-input
            :disabled="true"
            v-model="total_payments"
            title="Onlinebetalningar"
          />
          
          <p><a @click.prevent="show_details('ONLINE_PAYMENT')" href="">Detaljer</a></p>
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="12">
          <memlist-text-input
            :disabled="true"
            v-model="total_sms"
            title="SMS"
          />
          
          <p><a @click.prevent="show_details('SMS')" href="">Detaljer</a></p>
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="12">
          <memlist-text-input
            :disabled="true"
            v-model="total_bankid"
            title="BankID"
          />
          
          <p><a @click.prevent="show_details('BANKID')" href="">Detaljer</a></p>
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="12">
          <memlist-text-input
            :disabled="true"
            v-model="total_spar"
            title="SPAR"
          />
          
          <p><a @click.prevent="show_details('SPAR')" href="">Detaljer</a></p>
        </m-col>
      </m-row>

      <m-row class="mt-6">
        <m-col lg="12">
          <RightModalSaveAndCloseButtons
            :text="$t('COMMON.SAVE')"
            :spin="true"
            @click="on_save"
            @close="on_cancel"
            ref="saveButton"
          />
        </m-col>
      </m-row>
    </memlist-modal>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import CustomerBillingTransactionListModal from '@/view/pages/ml/customer_billing/CustomerBillingTransactionListModal.vue';

export default {
  name: 'CustomerBillingTHSInvoiceModal',
  components: {
    CustomerBillingTransactionListModal,
  },
  mixins: [ toasts ],
  props: ['id','next_invoice_date','license_fee','amount_transactions','index_pct'],
  data() {
    return {
      selected_type: 'spar',
      total_payments: 0,
      total_spar: 0,
      total_bankid: 0,
      total_sms: 0,
      total_invoice: 0,
      local_ths_invoice: {}
    };
  },
  watch: {
    
    id: {
      deep: true,
      handler(val) {
        
        
      },
      immediate: true,
    },
    
    currentCompanyId(newValue, oldvalue) {
      
    },
    currentPeriodId(newValue, oldvalue) {
      
    }
  },
  async mounted() {
  
  },
  computed: {
    calc_invoice_amount() {
      let amount = 0;

      amount += parseFloat(this.amount_transactions+'') || 0;
      amount += (parseFloat(this.license_fee+'') || 0) + (parseFloat(this.license_fee+'') || 0) * ((parseFloat(this.index_pct+'') || 0) / 100);

      return amount;
    },

    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'isTHS']),
  },

  methods: {

    async fetch_summary_transactions(id) {
      this.total_sms = await this.fetch_transactions_for_type('SMS', id);
      this.total_payments = await this.fetch_transactions_for_type('ONLINE_PAYMENT', id);
      this.total_bankid = await this.fetch_transactions_for_type('BANKID', id);
      this.total_invoice = await this.fetch_transactions_for_type('INVOICE', id);
      this.total_spar = await this.fetch_transactions_for_type('SPAR', id);
      
    },

    async fetch_transactions_for_type(type, id) {

      const body = {
        modules: ['REGISTER','RENEW','SENDOUT','EVENT','SETTLEMENT','LOGIN'],
        services: this.get_services_for_type(type),

        from_date: '2020-01-01',
        to_date: '2099-12-31',
        ths_invoice_id: id,
      };

      const res = await axios.post(`/transaction/count`, body);

      if (res.status === 200) {
        return res.data.amount;
      }
  
    },


    get_services_for_type(type) {
      let services = [];

      switch (type) {
        case 'SMS': {
          services = ['sinch'];
          break;
        }
        case 'SPAR': {
          services = ['spar'];
          break;
        }
        case 'INVOICE': {
          services = ['manual_payment','bg','memlist_invoice'];
          break;
        }
        case 'ONLINE_PAYMENT': {
          services = ['swish','epassi','stripe'];
          break;
        }
        case 'BANKID': {
          services = ['bankid'];
          break;
        }
        
      }
      
      return services;
    },

    show_details(type) {
      this.selected_type = type;
      this.$refs['customer-transactions-modal'].show();
    },

    async on_save() {
      if (this.local_ths_invoice.id) {
        const res = await axios.put(`/billing/ths_invoice/${this.local_ths_invoice.id}`, this.local_ths_invoice);

        if (res.status === 204) {
          this.$emit('updated', this.local_ths_invoice);
          this.toastr('success', this.$t('COMMON.OK'), this.$t('BILLING.THS_INVOICE_UPDATED'));
        }
      }
      else {
        const res = await axios.post(`/billing/ths_invoice`, this.local_ths_invoice);

        if (res.status === 201) {
          this.local_ths_invoice = res.data;
          this.$emit('created', this.local_ths_invoice);
          this.toastr('success', this.$t('COMMON.OK'), this.$t('BILLING.THS_INVOICE_CREATED'));
        }
      }

      this.$refs['saveButton'].stop();
    },

    on_cancel() {
      this.hide();
    },

    setup_invoice() {
      if (this.id) {
        this.fetch_ths_invoice(this.id);
        this.fetch_summary_transactions(this.id);
      }
      else {
        this.local_ths_invoice = {
          due_date: this.next_invoice_date,
          amount: this.calc_invoice_amount,
          is_paid: false,
        };

        this.fetch_summary_transactions();
      }
    },

    show() {
      this.setup_invoice();
      this.$refs['ths-invoice-modal'].show();
    },

    hide() {
      this.$refs['ths-invoice-modal'].hide();
    },

    async fetch_ths_invoice(id) {
      const res = await axios.get(`/billing/ths_invoice/${id}`);

      if (res.status === 200) {
        this.local_ths_invoice = res.data;
      }
    },

  },
  
};
</script>
